export default __webpack_public_path__ + "static/media/INMED AI STUDIO final-01 1.b6a444df.png";